import { inject, Injectable } from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';
import * as countryDataEn from 'i18n-iso-countries/langs/en.json';
import * as countryDataDe from 'i18n-iso-countries/langs/de.json';
import { TranslocoService } from '@jsverse/transloco';
import { MarkantSelectOption } from '@markant-platform/shared/util-helpers';

@Injectable({
  providedIn: 'root',
})
export class IsoCountryService {
  private readonly translocoService = inject(TranslocoService);

  private countriesIso = i18nIsoCountries;

  constructor() {
    i18nIsoCountries.registerLocale(countryDataEn);
    i18nIsoCountries.registerLocale(countryDataDe);
  }

  getCountryTranslation(countryCode: string, withCode = true): string {
    const activeLanguage = this.translocoService.getActiveLang()?.split('-')[0];
    const countryTranslated = this.countriesIso.getName(countryCode, activeLanguage);

    if (countryCode && countryTranslated) {
      if (withCode) {
        return `${countryTranslated} (${countryCode})`;
      }

      return `${countryTranslated}`;
    }

    return '';
  }

  getCountry(language: string): [string, string][] {
    return Object.entries(this.countriesIso.getNames(language)).filter(([key]) => key !== 'XK');
  }

  getSelectCountriesNames(language: string): MarkantSelectOption[] {
    return this.getCountry(language).map(([key, value]) => ({ value: key, representation: `${value} (${key})` }));
  }
}
